import { SPORTS_BOOK_ROUTE } from "@hypexone/uicore";

export const requiresLoginForNavigation = (navigationUrl: string): boolean =>
  navigationUrl.startsWith("/dc/") ||
  navigationUrl.includes("/casino") ||
  navigationUrl === SPORTS_BOOK_ROUTE ||
  navigationUrl.startsWith(`${SPORTS_BOOK_ROUTE}/`);
